sofistik-zoom-hero {
  picture {
    animation: scaleAnimation var(--hero-animation-duration, 10s) ease-in-out infinite;
  }
}

@keyframes scaleAnimation {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(var(--hero-animation-zoom, 1.1));
  }
}
